export default __webpack_public_path__ + "static/media/HUNKY_TEXT.76e164b1.png";